import { Checkbox } from '@/components/ui/checkbox';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { EMPTY_VALUE } from '@/constants/app.constants';
import { BOOKLIST_QUESTIONS, type BooklistSheet } from '../types/productRequisition.types';
import {
  EMPTY_BOOKLIST_ANSWERS,
  type BooklistAnswers,
  type BooklistDraft,
} from '../utils/sheetDrafts';

interface BooklistSheetTableProps {
  sheet: BooklistSheet;
  draft: BooklistDraft;
  onChange: (instituteId: number, answers: BooklistAnswers) => void;
}

export function BooklistSheetTable({ sheet, draft, onChange }: BooklistSheetTableProps) {
  return (
    <div className="overflow-auto rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-12">SL</TableHead>
            <TableHead className="min-w-56">Institute</TableHead>
            <TableHead>Thana</TableHead>
            {BOOKLIST_QUESTIONS.map((question) => (
              <TableHead key={question.key} className="text-center">
                {question.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {sheet.institutes.map((institute, index) => {
            const answers = draft[institute.instituteId] ?? EMPTY_BOOKLIST_ANSWERS;
            const isLocked = institute.answers?.isReview === true || !sheet.isOpen;

            return (
              <TableRow key={institute.instituteId}>
                <TableCell className="tabular-nums">{index + 1}</TableCell>
                <TableCell className="font-medium">{institute.instituteName}</TableCell>
                <TableCell>{institute.thanaName ?? EMPTY_VALUE}</TableCell>

                {BOOKLIST_QUESTIONS.map((question) => (
                  <TableCell key={question.key} className="text-center">
                    <Checkbox
                      disabled={isLocked}
                      checked={answers[question.key]}
                      aria-label={`${question.label} at ${institute.instituteName}`}
                      onCheckedChange={(checked) =>
                        onChange(institute.instituteId, {
                          ...answers,
                          [question.key]: checked === true,
                        })
                      }
                    />
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
